import axios from "axios";

export default function OfferitemProductDeleteService(offerId, itemId, productId) {
  return axios({
    method: 'DELETE',
    url: process.env.REACT_APP_API_HOST + "/offer/" + offerId + "/item/" + itemId + "/product/" + productId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
